const AVERAGE_SOLAR_PANEL_WATTAGE = 420 // Average solar panel wattage
const AVERAGE_SOLAR_PANEL_EFFICIENCY = 0.85 // Solar panels don't convert all incoming sunlight into electricity perfectly
const KW_CONVERSION_FACTOR = 0.001 // 1kW = 1000W
const SOLAR_HOURS_PER_YEAR = 900
const INJECTED_AMOUNT = 0.66 // 66% of the kVA is injected or 33% self consumption

/**
 * Convert amount of solar panels to kVA
 * @param {number} amount
 * @returns {number}
 */
export const convertAmountOfSolarPanelsToKva = (amount?: number): number => {
  return (amount || 0) * AVERAGE_SOLAR_PANEL_WATTAGE * AVERAGE_SOLAR_PANEL_EFFICIENCY * KW_CONVERSION_FACTOR
}

/**
 * Convert kVA to kWh
 * @param {number} kva
 * @returns {number}
 */
export const convertKvaToInjection = (kva: number): number => {
  return kva * SOLAR_HOURS_PER_YEAR * INJECTED_AMOUNT
}

/**
 * Convert injection (kWh) to amount of solar panels (reverses convertAmountOfSolarPanelsToKva + convertKvaToInjection)
 * @param {number} injection
 * @returns {number}
 */
export const convertInjectionToAmountOfSolarPanels = (injection: number): number => {
  return Math.round(
    injection /
      (AVERAGE_SOLAR_PANEL_WATTAGE * AVERAGE_SOLAR_PANEL_EFFICIENCY * KW_CONVERSION_FACTOR * SOLAR_HOURS_PER_YEAR * INJECTED_AMOUNT)
  )
}
